<h1 mat-dialog-title>{{'COMMON.DIALOG.CONFIRMATION_DIALOG.WARNING' | translate}}</h1>
<div mat-dialog-content>
    <mat-form-field class="mat-form-field-fluid">
        <mat-select
            [placeholder]="placeholderString"
            [(ngModel)]="selectedOption">
            <mat-option *ngFor="let item of items" [value]="item.id">
                <!-- <ng-template *ngIf="translatePath else description">
                    {{ translatePath + '.' + item.description | translate}}
                </ng-template>
                <ng-template #description> -->
					{{item.description}}
				<!-- </ng-template> -->
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button 
        mat-raised-button color="primary"  class="btn-return"
        cdkFocusInitial
        (click)="dialogRef.close(false)">
        {{'COMMON.DIALOG.CONFIRMATION_DIALOG.NO' | translate}}
    </button>
    <button 
        mat-raised-button color="primary"
        [disabled]="!selectedOption"
        (click)="dialogRef.close(selectedOption)">
        {{'COMMON.DIALOG.CONFIRMATION_DIALOG.YES' | translate}}
    </button>
</div>